import ConsolidatedHeader from "./ConsolidatedHeader";
export default ConsolidatedHeader;
